/** @type {import('../schema').ProcessDefinition} */
const presupuestos = {
  id: "presupuestos",
  name: "Presupuestos / cotizaciones",
  category: "finanzas",
  outcome: "Documento comercial PDF (propuesta de servicios), descargable.",
  trigger: "El Administrador/Super Admin abre Presupuestos.",
  actors: ["Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Carga de datos de una propuesta de servicios, vista previa en vivo y exportación a PDF para descarga.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Carga de datos",
      description:
        "Edificio, número de propuesta, servicios (tabla editable) y observaciones.",
      evidence: "src/screens/admin/Presupuestos.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "task",
      label: "Vista previa",
      description: "Renderiza el documento en vivo.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "decision",
      label: "¿El render fue exitoso?",
      description:
        "Si falla el render se muestra error y se reintenta.",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "document",
      label: "Generación de PDF",
      description:
        "Exporta el documento (captura DOM → PDF) para descarga.",
      evidence: "src/utils/presupuestoPdf.js",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "task",
      label: "Corrección y reintento",
      description: "Ante un fallo de render, el admin corrige y reintenta.",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "end",
      label: "PDF descargado",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "OK" },
    { from: "s3", to: "s5", label: "Error" },
    { from: "s5", to: "s2" },
    { from: "s4", to: "s6" },
  ],
};
export default presupuestos;
